<template>
    <div>
        <fieldset v-for="(spec, index1) in specs" :key="spec.id" class="form-group">
            <div class="row" style="color: #000000">
                <legend class="col-form-label col-2">{{ spec.name }}</legend>
                <!-- <div class="col-10" :data-spec-id="spec.id"></div> -->
                <div class="col-10">
                    <div v-for="(spec_val, index2) in validSpecVals(spec, index1)" :key="spec_val.id"
                        class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" :id="`spec-val-${spec_val.id}`"
                            @change="preventInvalidOptions" :name="`-spec-item-${spec.id}`" :value="spec_val.id"
                            v-model="selected_values[index1]">
                        <label class="form-check-label" :for="`spec-val-${spec_val.id}`">
                            {{ spec_val.value }}
                        </label>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
</template>
<script>
    import tools from "../../../library/tools";

    export default {
        props: {
            specs: {
                default() {
                    return [];
                }
            },
            storages: {
                default() {
                    return [];
                }
            },
            value: {
                default() {
                    return {};
                }
            }
        },
        watch: {
            storages(newValue, oldValue) {
                if (newValue.length && !oldValue.length) {
                    this.$nextTick(() => {
                        this.selected_values =
                            this.storages.length ? this.storages[0].spec_vals.map(item => item.id) : [];
                        this.preventInvalidOptions();
                    });
                }
            }
        },
        data() {
            return {
                myValue: {},
                selected_values: []
            };
        },
        mounted() {
        },
        methods: {
            construct_options_tree() {
                let storages = this.storages;
                /**
                 * specs in product should be:
                 * [
                 *     {
                 *         id: // spec_id,
                 *         name: // spec_name, 'color'
                 *     },
                 *     {
                 *         id: // spec_val_id,
                 *         name: // spec_name, 'size'
                 *     }
                 * ]
                 *
                 * specs in storage should be:
                 * [
                 *     {
                 *         id: // spec_val_id,
                 *         value: // spec_value, 'green'
                 *     },
                 *     {
                 *         id: // spec_val_id,
                 *         value: // spec_value, '12cm'
                 *     }
                 * ]
                 */
                storages.map((storage) => {
                    let previous, current;
                    let spec_vals = storage.spec_vals.map((spec_val, index) => {
                        let exist = false;
                        if (index === 0) previous = this.options_tree;
                        let olds = previous.children.filter(
                            (item) => item.id === spec_val.id
                        );
                        if (olds.length) {
                            exist = true;
                            current = olds[0];
                        } else {
                            current = {
                                id: spec_val.id,
                                value: spec_val.value,
                                product_spec_id: spec_val.product_spec_id,
                                children: [],
                            };
                        }
                        if (!exist) {
                            previous.children.push(current);
                        }
                        previous = current;
                        current = null;
                    });
                });
            },
            preventInvalidOptions(e) {
                let previous_storages, filtered_storages;
                if (this.selected_values.length) {
                    for (let index = 1; index <= this.selected_values.length; index++) {
                        filtered_storages = this.referencedStorages(index);
                        if (filtered_storages.length) {
                            previous_storages = filtered_storages;
                        } else {
                            this.selected_values = previous_storages[0].spec_vals.map(item => item.id);
                            filtered_storages = previous_storages;
                        }
                    }
                } else {
                    filtered_storages = this.storages;
                }
                this.myValue = filtered_storages[0];
                this.$emit('input', this.myValue);
            },

            // filter down referenced storages
            referencedStorages(index) {
                // decide how much value will be concern
                // when index is 0, no value will need concern
                // when index is 1, the `0` value will need concern
                let filter_values = this.selected_values.slice(0, index);
                return this.storages.filter(storage => {
                    // if this storage spec_vals doesn't content correct value
                    // then ignore
                    let valid = true;
                    // fetch all spec_vals id from storage
                    let content_ids = storage.spec_vals.map(item => item.id);
                    // walk through all of filter_values
                    filter_values.map(value => {
                        if (content_ids.indexOf(value) === -1) valid = false;
                    });
                    return valid;
                });
                return result;
            },
            validSpecVals(spec, index) {

                let beenReferencedSpecVals = (storages) => {
                    // filter to keep been referenced by storages's id
                    let valid_ids = [];
                    storages.map(storage => {
                        let internal_valid_ids = storage.spec_vals.map(item => item.id)
                            .filter(item => valid_ids.indexOf(item) === -1);
                        valid_ids.push(...internal_valid_ids);
                    });
                    return valid_ids;
                };

                // filter spec_value based on filterd storages
                let filterd_storages = this.referencedStorages(index);
                let specValFilter = (spec_val, index, spec_values) => {
                    // using filtered storages, get its spec_vals is.
                    return beenReferencedSpecVals(filterd_storages).indexOf(spec_val.id) !== -1;
                };
                return spec.values.filter(specValFilter);
            },
            validStorage() { }
        }
    };
</script>
<style lang=""></style>